import PropTypes from 'prop-types'
import { createContext, useContext, useMemo, useState } from 'react'

export const NewEditTemplateCollectionBodyTableContext = createContext({
    loading: false,
    setLoading: () => { },
})

export const NewEditTemplateCollectionBodyTableContextProvider = ({ children }) => {
    const [loading, setLoading] = useState(false)

    const values = useMemo(() => ({
        loading,
        setLoading,
    }), [
        loading,
    ])

    return (
        <NewEditTemplateCollectionBodyTableContext.Provider value={values}>
            {children}
        </NewEditTemplateCollectionBodyTableContext.Provider>
    )
}

NewEditTemplateCollectionBodyTableContextProvider.propTypes = {
    children: PropTypes.node.isRequired
}

export const useNewEditTemplateCollectionBodyTableContext = () => {
    const context = useContext(NewEditTemplateCollectionBodyTableContext)
    if (!context) {
        throw new Error('useNewEditTemplateCollectionBodyTableContext must be used within a NewEditTemplateCollectionBodyTableContextProvider')
    }
    return context
}